import { type ISettingsParam, Logger } from 'tslog';

type LogLevel = 'fatal' | 'error' | 'warn' | 'info' | 'debug' | 'trace' | 'silly';

const logLevelsMap = {
  /* eslint no-console: 0 */
  fatal: { level: 5, method: console.warn },
  error: { level: 5, method: console.warn },
  warn: { level: 4, method: console.warn },
  info: { level: 3, method: console.info },
  debug: { level: 2, method: console.debug },
  trace: { level: 0, method: console.log },
  silly: { level: 0, method: console.log },
};

export const DEFAULT_LOG_LEVEL: LogLevel = 'warn';

let debugEnabled = false;
export function isDebugEnabled() {
  return debugEnabled;
}

export function getLogger(debug?: boolean, settings?: ISettingsParam<unknown>): Logger<unknown> {
  const debugFlagFromLocalStorage = getLoggerDebugFlagFromLocalStorage();
  debugEnabled = debugFlagFromLocalStorage ?? debug;
  const logLevel = debugEnabled ? 'trace' : DEFAULT_LOG_LEVEL;

  return new Logger({
    minLevel: logLevelsMap[logLevel]?.level ?? 0,
    type: debugEnabled ? 'pretty' : 'json',
    hideLogPositionForProduction: true,
    metaProperty: 'meta',
    prettyLogTimeZone: 'UTC',
    stylePrettyLogs: false, // Disable colors because Firefox doesn't support them
    prettyLogTemplate: '{{hh}}:{{MM}}:{{ss}}:{{ms}}\t{{logLevelName}}\t{{name}}\t',
    overwrite: {
      formatLogObj: (maskedArgs: unknown[]) => ({ args: maskedArgs, errors: [] }),
      transportFormatted: (logMetaMarkup, logArgs) => {
        const logLevel = logMetaMarkup
          .split('\t')[1]
          .replace(/[^A-Z]/g, '')
          .toLowerCase() as LogLevel;

        logLevelsMap[logLevel].method(logMetaMarkup, ...logArgs);
      },
    },
    ...settings,
  });
}

function getLoggerDebugFlagFromLocalStorage(): boolean {
  let valueFromStorage: string | null = null;
  try {
    valueFromStorage = sessionStorage?.getItem('miplayer::debug') ?? localStorage?.getItem('miplayer::debug');
  } catch (_error) {
    // Ignore error
  }

  return valueFromStorage === 'true';
}
